import { MiniVertical } from '@app/services/http/mini-verticals.service';

export interface BreadcrumbPart {
  name: string;
  url: string;
}

/**
 * The /api/mini-verticals/:slug payload carries the hub category in
 * `relatedCategory` — NOT `mainCategory` (that field only exists on the
 * verticals endpoint). Reading mainCategory here produced nameless
 * "/undefined/hub" crumbs that Google flagged as "Unnamed item".
 * A crumb is only emitted when both its name and url resolve.
 */
export function buildMiniVerticalBreadcrumbParts(
  miniVertical: MiniVertical,
  hubIndexSuffix: string,
): BreadcrumbPart[] {
  const parts: BreadcrumbPart[] = [];

  const category = miniVertical?.relatedCategory ?? miniVertical?.mainCategory;
  if (category?.title && category?.slug) {
    parts.push({
      name: category.title,
      url: `/${category.slug}/${hubIndexSuffix}`,
    });
  }

  const vertical = miniVertical?.relatedVertical;
  if (vertical?.title && vertical?.url) {
    parts.push({
      name: vertical.title,
      url: vertical.url,
    });
  }

  const name = miniVertical?.h1 || miniVertical?.tT || miniVertical?.cat;
  if (name && miniVertical?.url) {
    parts.push({
      name,
      url: miniVertical.url,
    });
  }

  return parts;
}
